function handle_search_main() {
    hide_free_and_from_0()
}


function hide_free_and_from_0() {
    const PRICE_SELECTOR = 'a.product-grid-item__price';

    function shouldHide(el) {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        return text.includes('from $0.00') || text.includes('free');
    }

    function hideIn(root) {
        if (!root || root.nodeType !== 1) return;
        const matches = [];
        if (root.matches && root.matches(PRICE_SELECTOR)) matches.push(root);
        if (root.querySelectorAll) {
            root.querySelectorAll(PRICE_SELECTOR).forEach(function (el) { matches.push(el); });
        }
        matches.forEach(function (el) {
            if (shouldHide(el)) el.innerHTML = '&nbsp;';
        });
    }

    // Handle everything already on the page.
    hideIn(document.body);

    // Watch for lazy-loaded items added as the user scrolls.
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                hideIn(node);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
}
